// extracted by mini-css-extract-plugin
module.exports = {"ratioGraphLocked":"ratio-graph-module--ratio-graph-locked--3c3mA","ratioGraphLocked__icon":"ratio-graph-module--ratio-graph-locked__icon--2MRCi"};